// ErrorState.tsx — Centered failure message. Used as the
// fallback rendering when a route's primary data fetch rejects.

interface Props {
  message: string;
}

export function ErrorState({ message }: Props) {
  return (
    <div className="console-empty" role="alert">
      <span
        className="material-icons"
        style={{ color: 'var(--error)' }}
      >
        error_outline
      </span>
      <div className="console-empty-title">{message}</div>
    </div>
  );
}
